module.exports = {
	"1": {
		"name": "Australia",
		"short": "AU",
		"mask": "+61",
		"length": 9
	},
	"2": {
		"name": "Austria",
		"short": "AT",
		"mask": "+43",
		"length": 9
	},
	"3": {
		"name": "Azerbaijan",
		"short": "AZ",
		"mask": "+994",
		"length": 9
	},
	"5": {
		"name": "Algeria",
		"short": "DZ",
		"mask": "+213",
		"length": 9
	},
	"6": {
		"name": "American Samoa",
		"short": "AS",
		"mask": "+1",
		"length": 10
	},
	"7": {
		"name": "Anguilla",
		"short": "AI",
		"mask": "+1",
		"length": 10
	},
	"8": {
		"name": "Angola",
		"short": "AO",
		"mask": "+244",
		"length": 9
	},
	"9": {
		"name": "Andorra",
		"short": "AD",
		"mask": "+376",
		"length": 6
	},
	"11": {
		"name": "Antigua And Barbuda",
		"short": "AG",
		"mask": "+1",
		"length": 10
	},
	"12": {
		"name": "Argentina",
		"short": "AR",
		"mask": "+54",
		"length": 11
	},
	"13": {
		"name": "Armenia",
		"short": "AM",
		"mask": "+374",
		"length": 8
	},
	"14": {
		"name": "Aruba",
		"short": "AW",
		"mask": "+297",
		"length": 7
	},
	"15": {
		"name": "Afghanistan",
		"short": "AF",
		"mask": "+93",
		"length": 9
	},
	"16": {
		"name": "Bahamas",
		"short": "BS",
		"mask": "+1",
		"length": 10
	},
	"17": {
		"name": "Bangladesh",
		"short": "BD",
		"mask": "+880",
		"length": 10
	},
	"18": {
		"name": "Barbados",
		"short": "BB",
		"mask": "+1",
		"length": 10
	},
	"19": {
		"name": "Bahrain",
		"short": "BH",
		"mask": "+973",
		"length": 8
	},
	"20": {
		"name": "Belize",
		"short": "BZ",
		"mask": "+501",
		"length": 7
	},
	"21": {
		"name": "Belarus",
		"short": "BY",
		"mask": "+375",
		"length": 9
	},
	"22": {
		"name": "Belgium",
		"short": "BE",
		"mask": "+32",
		"length": 9
	},
	"23": {
		"name": "Benin",
		"short": "BJ",
		"mask": "+229",
		"length": 8
	},
	"24": {
		"name": "Bermuda",
		"short": "BM",
		"mask": "+1",
		"length": 10
	},
	"25": {
		"name": "Bulgaria",
		"short": "BG",
		"mask": "+359",
		"length": 8
	},
	"26": {
		"name": "Bolivia",
		"short": "BO",
		"mask": "+571",
		"length": 8
	},
	"27": {
		"name": "Bosnia And Herzegovina",
		"short": "BA",
		"mask": "+387",
		"length": 8
	},
	"28": {
		"name": "Botswana",
		"short": "BW",
		"mask": "+267",
		"length": 8
	},
	"29": {
		"name": "Brazil",
		"short": "BR",
		"mask": "+55",
		"length": 10
	},
	"30": {
		"name": "British Indian Ocean Territory",
		"short": "IO",
		"mask": "+246",
		"length": 7
	},
	"32": {
		"name": "Brunei Darussalam",
		"short": "BN",
		"mask": "+673",
		"length": 7
	},
	"33": {
		"name": "Burkina Faso",
		"short": "BF",
		"mask": "+226",
		"length": 8
	},
	"34": {
		"name": "Burundi",
		"short": "BI",
		"mask": "+257",
		"length": 8
	},
	"35": {
		"name": "Bhutan",
		"short": "BT",
		"mask": "+975",
		"length": 8
	},
	"36": {
		"name": "Vanuatu",
		"short": "VU",
		"mask": "+678",
		"length": 7
	},
	"38": {
		"name": "United Kingdom",
		"short": "GB",
		"mask": "+44",
		"length": 10
	},
	"39": {
		"name": "Hungary",
		"short": "HU",
		"mask": "+36",
		"length": 9
	},
	"40": {
		"name": "Venezuela",
		"short": "VE",
		"mask": "+58",
		"length": 10
	},
	"42": {
		"name": "Vietnam",
		"short": "VN",
		"mask": "+84",
		"length": 9
	},
	"43": {
		"name": "Gabon",
		"short": "GA",
		"mask": "+241",
		"length": 8
	},
	"44": {
		"name": "Haiti",
		"short": "HT",
		"mask": "+509",
		"length": 8
	},
	"45": {
		"name": "Guyana",
		"short": "GY",
		"mask": "+592",
		"length": 7
	},
	"46": {
		"name": "Gambia",
		"short": "GM",
		"mask": "+220",
		"length": 7
	},
	"47": {
		"name": "Ghana",
		"short": "GH",
		"mask": "+233",
		"length": 9
	},
	"48": {
		"name": "Guadeloupe",
		"short": "GP",
		"mask": "+590",
		"length": 9
	},
	"49": {
		"name": "Guatemala",
		"short": "GT",
		"mask": "+502",
		"length": 8
	},
	"50": {
		"name": "Guinea",
		"short": "GN",
		"mask": "+224",
		"length": 8
	},
	"51": {
		"name": "Guinea-Bissau",
		"short": "GW",
		"mask": "+245",
		"length": 7
	},
	"52": {
		"name": "Germany",
		"short": "DE",
		"mask": "+49",
		"length": 11
	},
	"53": {
		"name": "Honduras",
		"short": "HN",
		"mask": "+504",
		"length": 8
	},
	"54": {
		"name": "State of Palestine",
		"short": "PS",
		"mask": "+970",
		"length": 9
	},
	"55": {
		"name": "Grenada",
		"short": "GD",
		"mask": "+1",
		"length": 10
	},
	"56": {
		"name": "Greenland",
		"short": "GL",
		"mask": "+299",
		"length": 6
	},
	"58": {
		"name": "Guam",
		"short": "GU",
		"mask": "+1",
		"length": 10
	},
	"60": {
		"name": "Djibouti",
		"short": "DJ",
		"mask": "+253",
		"length": 8
	},
	"61": {
		"name": "Dominica",
		"short": "DM",
		"mask": "+1",
		"length": 10
	},
	"62": {
		"name": "Dominican Republic",
		"short": "DO",
		"mask": "+1",
		"length": 10
	},
	"63": {
		"name": "Egypt",
		"short": "EG",
		"mask": "+20",
		"length": 10
	},
	"64": {
		"name": "Zambia",
		"short": "ZM",
		"mask": "+260",
		"length": 9
	},
	"65": {
		"name": "Western Sahara",
		"short": "EH",
		"mask": "+212",
		"length": 9
	},
	"66": {
		"name": "Zimbabwe",
		"short": "ZW",
		"mask": "+263",
		"length": 9
	},
	"67": {
		"name": "Israel",
		"short": "IL",
		"mask": "+972",
		"length": 9
	},
	"68": {
		"name": "India",
		"short": "IN",
		"mask": "+91",
		"length": 10
	},
	"69": {
		"name": "Indonesia",
		"short": "ID",
		"mask": "+62",
		"length": 9
	},
	"70": {
		"name": "Jordan",
		"short": "JO",
		"mask": "+962",
		"length": 9
	},
	"71": {
		"name": "Iraq",
		"short": "IQ",
		"mask": "+964",
		"length": 10
	},
	"72": {
		"name": "Iran, Islamic Republic of",
		"short": "IR",
		"mask": "+98",
		"length": 10
	},
	"73": {
		"name": "Ireland",
		"short": "IE",
		"mask": "+353",
		"length": 9
	},
	"74": {
		"name": "Iceland",
		"short": "IS",
		"mask": "+354",
		"length": 7
	},
	"75": {
		"name": "Spain",
		"short": "ES",
		"mask": "+34",
		"length": 9
	},
	"76": {
		"name": "Italy",
		"short": "IT",
		"mask": "+39",
		"length": 10
	},
	"77": {
		"name": "Yemen",
		"short": "YE",
		"mask": "+967",
		"length": 9
	},
	"78": {
		"name": "Cape Verde",
		"short": "CV",
		"mask": "+238",
		"length": 7
	},
	"79": {
		"name": "Kazakstan",
		"short": "KZ",
		"mask": "+7",
		"length": 10
	},
	"80": {
		"name": "Cayman Islands",
		"short": "KY",
		"mask": "+1",
		"length": 10
	},
	"81": {
		"name": "Cambodia",
		"short": "KH",
		"mask": "+855",
		"length": 8
	},
	"82": {
		"name": "Cameroon",
		"short": "CM",
		"mask": "+237",
		"length": 8
	},
	"83": {
		"name": "Canada",
		"short": "CA",
		"mask": "+1",
		"length": 10
	},
	"84": {
		"name": "Qatar",
		"short": "QA",
		"mask": "+974",
		"length": 8
	},
	"85": {
		"name": "Kenya",
		"short": "KE",
		"mask": "+254",
		"length": 9
	},
	"86": {
		"name": "Kiribati",
		"short": "KI",
		"mask": "+686",
		"length": 5
	},
	"87": {
		"name": "Taiwan, Province of China",
		"short": "TW",
		"mask": "+886",
		"length": 9
	},
	"88": {
		"name": "Korea, Democratic People's Republic of",
		"short": "KP",
		"mask": "+850",
		"length": 10
	},
	"89": {
		"name": "Cocos (Keeling) Islands",
		"short": "CC",
		"mask": "+61",
		"length": 9
	},
	"90": {
		"name": "Colombia",
		"short": "CO",
		"mask": "+57",
		"length": 10
	},
	"91": {
		"name": "Comoros",
		"short": "KM",
		"mask": "+269",
		"length": 7
	},
	"92": {
		"name": "Costa Rica",
		"short": "CR",
		"mask": "+506",
		"length": 8
	},
	"93": {
		"name": "Cote D'Ivoire",
		"short": "CI",
		"mask": "+255",
		"length": 8
	},
	"94": {
		"name": "Cuba",
		"short": "CU",
		"mask": "+53",
		"length": 8
	},
	"95": {
		"name": "Kuwait",
		"short": "KW",
		"mask": "+965",
		"length": 7
	},
	"96": {
		"name": "Kyrgyzstan",
		"short": "KG",
		"mask": "+996",
		"length": 9
	},
	"97": {
		"name": "Lao People's Democratic Republic",
		"short": "LA",
		"mask": "+856",
		"length": 10
	},
	"98": {
		"name": "Lesotho",
		"short": "LS",
		"mask": "+266",
		"length": 8
	},
	"99": {
		"name": "Liberia",
		"short": "LR",
		"mask": "+231",
		"length": 7
	},
	"100": {
		"name": "Lebanon",
		"short": "LB",
		"mask": "+961",
		"length": 8
	},
	"101": {
		"name": "Libyan Arab Jamahiriya",
		"short": "LY",
		"mask": "+218",
		"length": 9
	},
	"102": {
		"name": "Lithuania",
		"short": "LT",
		"mask": "+218",
		"length": 9
	},
	"103": {
		"name": "Luxembourg",
		"short": "LU",
		"mask": "+352",
		"length": 9
	},
	"104": {
		"name": "Mauritius",
		"short": "MU",
		"mask": "+230",
		"length": 7
	},
	"105": {
		"name": "Mauritania",
		"short": "MR",
		"mask": "+222",
		"length": 8
	},
	"106": {
		"name": "Madagascar",
		"short": "MG",
		"mask": "+261",
		"length": 9
	},
	"107": {
		"name": "Mayotte",
		"short": "YT",
		"mask": "+262",
		"length": 9
	},
	"108": {
		"name": "Malawi",
		"short": "MW",
		"mask": "+265",
		"length": 9
	},
	"109": {
		"name": "Malaysia",
		"short": "MY",
		"mask": "+60",
		"length": 9
	},
	"110": {
		"name": "Mali",
		"short": "ML",
		"mask": "+223",
		"length": 8
	},
	"111": {
		"name": "Maldives",
		"short": "MV",
		"mask": "+960",
		"length": 7
	},
	"112": {
		"name": "Malta",
		"short": "MT",
		"mask": "+356",
		"length": 8
	},
	"113": {
		"name": "Morocco",
		"short": "MA",
		"mask": "+212",
		"length": 9
	},
	"114": {
		"name": "Marshall Islands",
		"short": "MH",
		"mask": "+692",
		"length": 7
	},
	"115": {
		"name": "Mexico",
		"short": "MX",
		"mask": "+52",
		"length": 11
	},
	"116": {
		"name": "Micronesia, Federated States of",
		"short": "FM",
		"mask": "+691",
		"length": 7
	},
	"117": {
		"name": "Mozambique",
		"short": "MZ",
		"mask": "+258",
		"length": 9
	},
	"118": {
		"name": "Moldova, Republic of",
		"short": "MD",
		"mask": "+373",
		"length": 8
	},
	"119": {
		"name": "Monaco",
		"short": "MC",
		"mask": "+377",
		"length": 9
	},
	"120": {
		"name": "Mongolia",
		"short": "MN",
		"mask": "+976",
		"length": 8
	},
	"121": {
		"name": "Montserrat",
		"short": "MS",
		"mask": "+1",
		"length": 10
	},
	"122": {
		"name": "Myanmar",
		"short": "MM",
		"mask": "+95",
		"length": 8
	},
	"123": {
		"name": "Namibia",
		"short": "NA",
		"mask": "+264",
		"length": 9
	},
	"124": {
		"name": "Nauru",
		"short": "NR",
		"mask": "+674",
		"length": 7
	},
	"125": {
		"name": "Nepal",
		"short": "NP",
		"mask": "+977",
		"length": 10
	},
	"126": {
		"name": "Niger",
		"short": "NE",
		"mask": "+227",
		"length": 8
	},
	"127": {
		"name": "Nigeria",
		"short": "NG",
		"mask": "+234",
		"length": 10
	},
	"129": {
		"name": "Netherlands",
		"short": "NL",
		"mask": "+31",
		"length": 9
	},
	"130": {
		"name": "Nicaragua",
		"short": "NI",
		"mask": "+505",
		"length": 8
	},
	"131": {
		"name": "Niue",
		"short": "NU",
		"mask": "+683",
		"length": 4
	},
	"132": {
		"name": "New Zealand",
		"short": "NZ",
		"mask": "+64",
		"length": 9
	},
	"133": {
		"name": "New Caledonia",
		"short": "NC",
		"mask": "+687",
		"length": 6
	},
	"134": {
		"name": "Norway",
		"short": "NO",
		"mask": "+47",
		"length": 8
	},
	"135": {
		"name": "United Arab Emirates",
		"short": "AE",
		"mask": "+971",
		"length": 9
	},
	"136": {
		"name": "Oman",
		"short": "OM",
		"mask": "+968",
		"length": 8
	},
	"138": {
		"name": "Norfolk Island",
		"short": "NF",
		"mask": "+672",
		"length": 6
	},
	"139": {
		"name": "Christmas Island",
		"short": "CX",
		"mask": "+61",
		"length": 9
	},
	"141": {
		"name": "Cook Islands",
		"short": "CK",
		"mask": "+682",
		"length": 5
	},
	"143": {
		"name": "Pakistan",
		"short": "PK",
		"mask": "+92",
		"length": 10
	},
	"144": {
		"name": "Palau",
		"short": "PW",
		"mask": "+680",
		"length": 7
	},
	"145": {
		"name": "Papua New Guinea",
		"short": "PG",
		"mask": "+675",
		"length": 7
	},
	"146": {
		"name": "Paraguay",
		"short": "PY",
		"mask": "+595",
		"length": 9
	},
	"147": {
		"name": "Peru",
		"short": "PE",
		"mask": "+51",
		"length": 9
	},
	"148": {
		"name": "Poland",
		"short": "PL",
		"mask": "+48",
		"length": 9
	},
	"149": {
		"name": "Portugal",
		"short": "PT",
		"mask": "+351",
		"length": 9
	},
	"150": {
		"name": "Puerto Rico",
		"short": "PR",
		"mask": "+1",
		"length": 10
	},
	"151": {
		"name": "Congo",
		"short": "CG",
		"mask": "+243",
		"length": 9
	},
	"152": {
		"name": "Korea, Republic of",
		"short": "KR",
		"mask": "+82",
		"length": 10
	},
	"153": {
		"name": "Macedonia, The Former Yugoslav Republic of",
		"short": "MK",
		"mask": "+389",
		"length": 8
	},
	"154": {
		"name": "Russian Federation",
		"short": "RU",
		"mask": "+7",
		"length": 10
	},
	"155": {
		"name": "Rwanda",
		"short": "RW",
		"mask": "+250",
		"length": 9
	},
	"156": {
		"name": "Romania",
		"short": "RO",
		"mask": "+40",
		"length": 9
	},
	"157": {
		"name": "El Salvador",
		"short": "SV",
		"mask": "+503",
		"length": 8
	},
	"158": {
		"name": "Samoa",
		"short": "WS",
		"mask": "+685",
		"length": 6
	},
	"159": {
		"name": "San Marino",
		"short": "SM",
		"mask": "+378",
		"length": 8
	},
	"160": {
		"name": "Sao Tome And Principe",
		"short": "ST",
		"mask": "+239",
		"length": 7
	},
	"161": {
		"name": "Saudi Arabia",
		"short": "SA",
		"mask": "+966",
		"length": 9
	},
	"162": {
		"name": "Swaziland",
		"short": "SZ",
		"mask": "+268",
		"length": 8
	},
	"163": {
		"name": "Northern Mariana Islands",
		"short": "MP",
		"mask": "+1",
		"length": 10
	},
	"164": {
		"name": "Seychelles",
		"short": "SC",
		"mask": "+248",
		"length": 7
	},
	"165": {
		"name": "Saint Pierre And Miquelon",
		"short": "PM",
		"mask": "+508",
		"length": 6
	},
	"166": {
		"name": "Senegal",
		"short": "SN",
		"mask": "+221",
		"length": 9
	},
	"167": {
		"name": "Saint Vincent And The Grenadines",
		"short": "VC",
		"mask": "+1",
		"length": 10
	},
	"168": {
		"name": "Saint Kitts And Nevis",
		"short": "KN",
		"mask": "+1",
		"length": 10
	},
	"169": {
		"name": "Saint Lucia",
		"short": "LC",
		"mask": "+1",
		"length": 10
	},
	"170": {
		"name": "Serbia",
		"short": "RS",
		"mask": "+381",
		"length": 9
	},
	"171": {
		"name": "Singapore",
		"short": "SG",
		"mask": "+65",
		"length": 8
	},
	"172": {
		"name": "Syrian Arab Republic",
		"short": "SY",
		"mask": "+963",
		"length": 9
	},
	"173": {
		"name": "Slovakia (Slovak Republic)",
		"short": "SK",
		"mask": "+421",
		"length": 9
	},
	"174": {
		"name": "Slovenia",
		"short": "SI",
		"mask": "+386",
		"length": 8
	},
	"175": {
		"name": "Solomon Islands",
		"short": "SB",
		"mask": "+677",
		"length": 7
	},
	"176": {
		"name": "Somalia",
		"short": "SO",
		"mask": "+252",
		"length": 8
	},
	"177": {
		"name": "Sudan",
		"short": "SD",
		"mask": "+249",
		"length": 9
	},
	"178": {
		"name": "Suriname",
		"short": "SR",
		"mask": "+597",
		"length": 7
	},
	"179": {
		"name": "Sierra Leone",
		"short": "SL",
		"mask": "+232",
		"length": 8
	},
	"180": {
		"name": "Tajikistan",
		"short": "TJ",
		"mask": "+992",
		"length": 9
	},
	"181": {
		"name": "Thailand",
		"short": "TH",
		"mask": "+66",
		"length": 9
	},
	"182": {
		"name": "Tanzania, United Republic of",
		"short": "TZ",
		"mask": "+255",
		"length": 9
	},
	"183": {
		"name": "Turks And Caicos Islands",
		"short": "TC",
		"mask": "+1",
		"length": 10
	},
	"184": {
		"name": "Togo",
		"short": "TG",
		"mask": "+228",
		"length": 8
	},
	"185": {
		"name": "Tokelau",
		"short": "TK",
		"mask": "+676",
		"length": 7
	},
	"186": {
		"name": "Tonga",
		"short": "TO",
		"mask": "+676",
		"length": 7
	},
	"187": {
		"name": "Trinidad And Tobago",
		"short": "TT",
		"mask": "+1",
		"length": 10
	},
	"188": {
		"name": "Tuvalu",
		"short": "TV",
		"mask": "+688",
		"length": 6
	},
	"189": {
		"name": "Tunisia",
		"short": "TN",
		"mask": "+216",
		"length": 8
	},
	"190": {
		"name": "Turkmenistan",
		"short": "TM",
		"mask": "+993",
		"length": 8
	},
	"191": {
		"name": "Uganda",
		"short": "UG",
		"mask": "+256",
		"length": 9
	},
	"192": {
		"name": "Uzbekistan",
		"short": "UZ",
		"mask": "+998",
		"length": 9
	},
	"193": {
		"name": "Ukraine",
		"short": "UA",
		"mask": "+380",
		"length": 9
	},
	"194": {
		"name": "Wallis And Futuna Islands",
		"short": "WF",
		"mask": "+681",
		"length": 6
	},
	"195": {
		"name": "Uruguay",
		"short": "UY",
		"mask": "+598",
		"length": 8
	},
	"196": {
		"name": "Faroe Islands",
		"short": "FO",
		"mask": "+298",
		"length": 6
	},
	"197": {
		"name": "Fiji",
		"short": "FJ",
		"mask": "+679",
		"length": 7
	},
	"198": {
		"name": "Philippines",
		"short": "PH",
		"mask": "+63",
		"length": 10
	},
	"199": {
		"name": "Finland",
		"short": "FI",
		"mask": "+358",
		"length": 9
	},
	"200": {
		"name": "Falkland Islands (Malvinas)",
		"short": "FK",
		"mask": "+500",
		"length": 5
	},
	"201": {
		"name": "French Polynesia",
		"short": "PF",
		"mask": "+689",
		"length": 9
	},
	"203": {
		"name": "Central African Republic",
		"short": "CF",
		"mask": "+236",
		"length": 8
	},
	"204": {
		"name": "Chad",
		"short": "TD",
		"mask": "+235",
		"length": 8
	},
	"205": {
		"name": "Montenegro",
		"short": "ME",
		"mask": "+382",
		"length": 8
	},
	"206": {
		"name": "Czech Republic",
		"short": "CZ",
		"mask": "+420",
		"length": 9
	},
	"207": {
		"name": "Chile",
		"short": "CL",
		"mask": "+56",
		"length": 9
	},
	"208": {
		"name": "Sweden",
		"short": "SE",
		"mask": "+46",
		"length": 9
	},
	"209": {
		"name": "Svalbard And Jan Mayen Islands",
		"short": "SJ",
		"mask": "+47",
		"length": 8
	},
	"210": {
		"name": "Sri Lanka",
		"short": "LK",
		"mask": "+94",
		"length": 9
	},
	"211": {
		"name": "Ecuador",
		"short": "EC",
		"mask": "+593",
		"length": 9
	},
	"212": {
		"name": "Equatorial Guinea",
		"short": "GQ",
		"mask": "+240",
		"length": 9
	},
	"213": {
		"name": "Eritrea",
		"short": "ER",
		"mask": "+291",
		"length": 7
	},
	"214": {
		"name": "Estonia",
		"short": "EE",
		"mask": "+372",
		"length": 8
	},
	"216": {
		"name": "South Africa",
		"short": "ZA",
		"mask": "+27",
		"length": 9
	},
	"218": {
		"name": "Jamaica",
		"short": "JM",
		"mask": "+1",
		"length": 10
	},
	"219": {
		"name": "Japan",
		"short": "JP",
		"mask": "+81",
		"length": 10
	}
};


//////////////////
// WEBPACK FOOTER
// ./js/shared/dictionaries/fast-join-countries/en.json
// module id = 1819
// module chunks = 2